import api from './api'

export type ReportForUser = {
    formattedData: Array<unknown>
}

const loadReportForUser = (
    reportId: number,
    chargePointUserId: string,
    interval: string,
    timeZone: string
): Promise<ReportForUser> =>
    api<ReportForUser>({ path: `/reports/${reportId}`, query: { chargePointUserId, interval, timeZone } })

export default loadReportForUser
